import React,{Component}   from 'react';
import minganci1 from './assets/img/minganci1.jpg';
import tingchechangshiyitu from './assets/img/tingchechangshiyitu.png';

class Section$ extends Component {
    
    showDrawer = (data) => {
        this.props.enclosureShow(data.target.id,data.target.title)
    }
    
    render(){
        return(
            <div style={{textIndent: '2em'}}>
            <div style={{textAlign: 'center'}}>
                <br/>
                <h1 name="0-3" className="point" id="0-3">第四章 安全管理制度</h1></div>
            <div style={{textIndent: '2em'}}>
                <br/>
                <h2 name="0-3-0" className="point" id="0-3-0">车辆安全管理细则</h2>
                <h3 name="0-3-0-0" className="point" id="0-3-0-0">一、 目的</h3>
                <p>为了严格管理车辆，合理使用车辆，节约费用开支，最大限度地发挥车辆的使用效益，以适应企业公务用车的需要，特制定本细则。</p>
                <h3 name="0-3-0-1" className="point" id="0-3-0-1">二、适用范围</h3>
                <p>本制度适用于云豪集团各部门。</p>

                <h3 name="0-3-0-2" className="point" id="0-3-0-2">三、车辆管理部门职责</h3>
                <p>1.集团所有车辆的交通安全、购置、报废、转让及对外事宜，统一由资产部管理。</p>
                <p>2.集团公司所有取得驾驶证人员必须报备到资产部，根据实际驾龄驾驶机动车的安全意识等综合因素经安全小组审核通过后才可以动用公司车辆。</p>
                <p>3.部门配合监察部代表集团监督、检查车辆使用部门的日常管理和车辆行车记录、修理记录、加油记录、安全记录。 </p>
                <p>4.定期组织全集团驾驶员进行行车安全教育和考核，进行安全常识、交通法规、交通安全的学习和教育。</p>
                <p>以上各条对相关责任人考核0-200分/项，考核权归监察部。
                </p>
                <h3 name="0-3-0-3" className="point" id="0-3-0-3">四、驾驶人职责</h3>
                <p>1. 服从主管车辆部门和所在部门领导的管理和教育，自觉遵守交通法规和集团的相关规章制度，做到知法、懂法、守法。</p>
                <p>2. 各部门驾驶员及负责人认真做好车辆的日常保养工作，及时检查，排除车辆的故障，严禁带病出车，使车辆经常处于完好状态，确保行车安全。</p>
                <p>3. 凡进入集团及各分公司的车辆（含私家车）按指定位置停放，且停放整齐有序。若车辆因任意放置而导致损毁、失窃，均由驾驶员赔偿损失。 </p>
                <p>3.1 进入停车场的车辆须持有单位发放的有效车证，车辆进入停车场时要将车证放在车辆挡风玻璃左侧，以便纪检委检查。</p>
                <p>3.2 车辆停放后,司机需做好车辆的检查,并锁好车门、窗,带走贵重物品,若有丢失,单位概不负责。</p>
                <p>3.3 进场车辆严禁在场内加油、修车、试刹车,禁止任何人在场内学习驾驶车辆。</p>
                <p>3.4 场内各种车辆停放需按停车场示意图规定区域停放,注意前后左右车辆安全距离,不得乱停乱放。</p>
                <p>3.5 机动车辆在单位院内行驶，时速不得超过10km/h,严禁超速行驶。</p>
                <p>3.6 不准在车行道、消防通道上停放车辆，机动车辆只能在停车场划线车位内停放。</p>
                <p>3.7 停车场内按消防要求配备灭火器，由资产部安排专人定期检查及管理使用。</p>
                <p>3.8 请各部门负责人将物资按指定区域码放整齐、遮盖存放。</p>
                <p>具体车辆停放区域如图所示：</p>
                <img src={tingchechangshiyitu} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
                <p>以上各条对相关责任人考核0-200分/项，考核权归监察部。 </p>

                <h3 name="0-3-0-4" className="point" id="0-3-0-4">五、车辆保养及维修管理</h3>
                <p>1. 车辆需要维修、保养时，必须到集团指定的地点进行。如司机私自找修理厂维修车辆，不予报销相关维修费用(特殊情况除外，经上级领导批准后办理)。</p>
                <p>2. 司机应随时掌握车辆维修进度并监测维修质量，在每次维修后，应认真做好维修记录，主管部门对车辆的维修质量进行监督检查。</p>
                <p>3. 报修车辆修复后，司机接车时应对所修项目认真检查无误，在维修项目单签字确认，交回资产部复核。如发现问题及时和车辆所在部门领导联系并向承修单位提出，确保修车质量。</p>

                <p>以上各条对相关责任人考核0-200分/项，考核权归监察部。</p>
                <h3 name="0-3-0-5" className="point" id="0-3-0-5">六、车辆违章及事故处理</h3>
                <p>驾驶员在驾驶车辆时，如有违章和肇事，按下列规定进行处罚。</p>
                <p>1. 驾驶员违章和肇事必须立即报告部门主管及主管部门，如有隐瞒不报，一经发现，视情节轻重给予200-500积分处罚或警告处分。</p>
                <p>2. 凡酒后驾车和私自交予非专职司机驾车发生交通事故末报案，私自处理者，一切损失由司机个人承担，给予200-500积分处罚且行政警告处分。 </p>
                <p>3. 发生交通肇事后，驾驶员破坏、逃离现场，一切经济损失和法律责任由司机个人承担，集团给予取消驾驶资格处分，且视情节轻重给予100-1000积分。</p>
                <p>4. 驾驶员因违章或证件不全被罚款的，罚款不予报销，由驾驶员自行承担，且考核200-500积分。</p>
                <p>5. 车辆违章及事故处理细则参照 《云豪集团安全生产事故（事件）处理规则》和《云豪集团交通事故处理办法》补充条款处理。</p>
                <br/>
                <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure41' title="《云豪集团安全生产事故（事件）处理规则》" onClick={(value)=>this.showDrawer(value)}>《云豪集团安全生产事故（事件）处理规则》</a></div>
                <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure42' title="《云豪集团交通事故处理办法》" onClick={(value)=>this.showDrawer(value)}>《云豪集团交通事故处理办法》</a></div>
                <br/>
                <br/>
                <h2 name="0-3-1" className="point" id="0-3-1">二、防火防盗安全细则</h2>
                <h3 name="0-3-1-0" className="point" id="0-3-1-0">防火防盗管理细则</h3>
                <p>为了保护企业财产及工作人员生命安全，保障各项工作的顺利进行，做好防火防盗工作。根据有关消防法规，结合本公司具体情况制定此管理制度，本规定适用于云豪集团各部门所有员工。 </p>
                {/* <h4>一、安全领导小组</h4> */}
                <p>公司的安全工作，实行“预防为主，防消结合”的方针，由纪律检查委员会的成员负责实施。</p>
                {/* <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure43' title="云豪集团安全小组名单" onClick={(value)=>this.showDrawer(value)}>云豪集团安全小组名单</a></div>
                <br/> */}
                {/* <h4>二、 防火防盗安全的组织与结构</h4> */}
                <p>1、 公司全体员工都应增强消防安全意识并承担安全防火防盗的责任和义务；</p>
                <p>2、 各办公区设计安装的消防设施，如消防龙头、水管、烟感报警器，以及其他消防器材要保证足量有效。消防设施、安全设施的更换、维修和配置，由资产部部统一负责，其他部室和个人不得擅自调换。上述消防设备及器材不得借故移作他用；</p>
                <p>3、 全体员工不论在宿舍或工作区，一律不许使用烧水壶、小太阳等大功率电器，严禁私拉乱接电源线。特殊情况使用需上报管理公司（中心）和资产部，资产部对线路进行评估、安全落实到人方可使用；</p>
                <p>4、全体员工提高安全意识，各办公区及宿舍内勿放私人贵重物品，出入随手关门，在集中学习或开会、休息时，各部室和库房、车间最后离开的人员要做到关灯、断电、关窗、锁门，防止发生火灾或被盗；</p>
                <p>5、加强值班、值宿工作，值班人员做好公司的防火防盗工作，发现情况及时报告，并采取有效措施降低损害程度；值班期间严格遵守以下规定：</p>
                <p>5.1不准随意脱岗或擅离职守；</p>
                <p>5.2不准留外来人员住宿；</p>
                <p>5.3不准在值班期间喝酒、打扑克、麻将等活动；</p>
                <p>5.4认真最好巡逻检查工作，将检查情况记录在册。</p>
                <p>5.5认真做好交接班工作。</p>
                <p>5.6 对发生的案件和时间及时上报。</p>
                <p>6、全体员工提高防火意识，及时清理库房、办公区等地的杨柳絮、落叶等杂物，必要时采用湿化处理方式；禁烟区严禁吸烟，设立专门吸烟室，烟头需湿化后进行清理。</p>
                <p>7、易燃易爆物品，禁止在电源、火源、气源等处存放。</p>
                <p>如有违反上述1-8条款考核相关责任人0-500分，若造成火灾或被盗者，追究负责人和直接责任者的责任。</p>

                {/* <h4>三、 安全职责</h4>
                <p>1、公司全体员工都应增强消防安全意识并承担安全防火防盗的责任和义务。</p>
                <p>2、各部门安全员在安全领导小组领导下，结合本部门的具体情况落实本部门的安全措施制度。安全员，应在每日下班前，对本工作部位进行一次安全检查;每星期做一次全面检查;公司安全领导小组不定期检查公司的各项安全措施;完善逐级检查制度以便及时发现和消除安全隐患，考核积分0-500分；</p>
                <p>3、各办公区设计安装的消防设施，如消防龙头、水管、烟感报警器，以及其他消防器材要保证足量有效。上述消防设备及器材不得借故移作他用，考核积分0-200分；</p>
                <p>4、全体员工不论在宿舍或工作区，一律不许使用烧水壶、小太阳等大功率电器，严禁私拉乱接电源线。特殊情况使用需上报管理公司（中心）、后勤保障部对线路进行评估、安全落实到人方可使用，考核积分0-200分；</p>
                <p>5、全体员工提高安全意识，各办公区及宿舍内勿放私人贵重物品，出入随手关门，最后离开的人员要检查电器是否关闭并锁好门窗。考核积分0-200分；</p>
                <p>6、全体员工提高防火意识，及时清理库房、办公区等地的杨柳絮、落叶等杂物，必要时采用加湿处理方式；禁烟区严禁吸烟，设立专门吸烟室，烟头需加湿后进行清理。 考核积分0-500分；</p>
                <h3 name="0-3-1-1" className="point" id="0-3-1-1">2、安全员管理制度</h3>
                <h4>一、安全员岗位职责</h4>
                <p>1、在集团安全小组的领导下，负责生产和生活安全工作。</p>
                <p>2、负责检查本部门安全生产制度、措施的执行情况。</p>
                <p>3、负责制订安全教育计划，进行安全培训。</p>
                <p>4、负责日常安全检查，对存在的隐患及时整改。</p>
                <p>5、负责检查安全设施及消防器材的完好情况，及时更换过期失效物品。</p>
                <p>6、对职工的个人防护及操作行为进行监督检查，及时纠正不规范或违章现象。</p>
                <p>7、发生工伤事故时，及时赶赴现场调查，写出调查材料，按“四不放过”的原则处理，制订整改措施。</p>
                <p>8、分析安全状况，及时采取预防措施，消除不安全因素。</p>
                <p>9、负责对新员工、实习生进行企业“三级”安全教育培训，培训时间协同云豪学院或人力资源部。</p>
                <p>10、每月15日、30日各上交一份安全报告，总结汇报所属责任区的安全状况。</p>
                <p>11、负责宿舍区域安全排查工作（包括但不限于宿舍用电、用水、环境卫生等），人员实行轮换制。</p>
                <p>12、安全员岗位职责依据行政单位的工作指示、通知等随时进行修正或增加。</p>
                <h4>二、任职要求</h4>
                <p>1、忠诚企业，企业理念和企业精神强。</p>
                <p>2、安全意识强，严格遵守国家法律法规。</p>
                <p>3、安全员应保证在发生问题时，及时到场处置。</p>
                <p>4、熟知公司的安全规章制度。</p>
                <p>5、熟知公司的体系文件，并能熟练运作。</p>
                <h4>三、考核标准</h4>
                <p>1、在各级领导及后勤保障部和纪律检查委员会日常检查中，发现问题的，按照相关规定，对安全员处以0-200积分的考核。</p>
                <p>2、监督检查教育不及时、不到位，发生安全事故的，考核安全员200积分起，根据事故严重程度，上不封顶。</p>
                <p>3、安全员拒不履行企业“三级”安全教育培训工作的，考核200积分起。</p>
                <p>4、安全员未按规定时间上报安全报告的，第一次考核100积分，第二次考核200积分，第三次清除出安全小组并通报批评。</p>
                <p>5、安全员积分考核由纪律检查委员会负责。</p> */}
                <br/>
                <h2 name="0-3-2" className="point" id="0-3-2">三、车间生产安全细则</h2>
                <h3 name="0-3-2-0" className="point" id="0-3-2-0">1、汽车维修工作安全</h3>
                <h4 name="0-3-2-0-0" className="point" id="0-3-2-0-0">1.1、工作环境的安全</h4>
                <p>对维修车间的一般要求是：</p>
                <p>维修企业建筑布局和结构应当合理，维修工位和车辆通道有合理的搭配，使维修车辆进出方便；配有完善的消防设施、消防安全通道和应急逃生通道。</p>
                <p>每个维修工位要有足够的面积和高度，一般轿车维修工位的面积不小于4m×7m，高度不小于4m。维修车间应配备专用汽车尾气排放设备，喷漆车间应当配有专用的通风装置，以保证通风良好。</p>
                <p>维修车间的地面应当采用水泥或水磨石，不要采用光滑的瓷砖地面。采光应当良好，灯光应当齐全，并达到一定的亮度，避免出现死角。维修车间应当有合理的供排水系统。</p>
                <p>维修车间应有车辆的专用通道、车辆的移动路线，并设置必要的限速牌、转弯处的反光镜等交通设施。维修车间的车辆通道上不要停放车辆，不要摆放任何物品。</p>
                <p>电力配置合理，插座布局满足要求，配有漏电保护器。</p>
                <h4 name="0-3-2-0-1" className="point" id="0-3-2-0-1">1.2、个人安全防护 </h4>
                <p>（1）维修企业应当教育和督促全体人员严格执行本单位的安全生产规章制度和安全操作规程，依法为从业人员办理工伤保险。</p>
                <p>（2）维修企业的特种作业人员，必须按国家有关规定经专门的安全作业培训，取得特种作业资格证书，方可上岗作业。在工作场所进行工作时，应当穿戴防护用品，包括：护目镜、工作帽、手套、工作鞋和合身的工作服等。</p>
                <p>（3）维修人员应当接受安全生产教育和培训，掌握安全生产知识，提高安全意识，增强事故预防和应急处理能力。</p>
                <p>（4）维修人员应了解作业场所和工作岗位存在的危险因素、防范措施以及事故应急措施，及时对维修企业的安全生产工作提出建议。维修作业时，应当严格遵守本企业的安全生产规章制度和操作规程，服从管理，正确使用劳动防护用品。</p>
                <p>（5）维修人员发现事故隐患或不安全因素，应当及时向现场管理人员汇报，接到报告的人员应当及时处理。企业管理人员不得违章指挥，不能违反安全生产法律、法规，侵犯维修人员合法权益。</p>
                <p>（6）搬运重物时要量力而行，确认抓牢物体后贴身用脚力抬升，搬运途中不要扭腰变向，必要时可整个身躯转向。放下重物时要保持物体贴身，挺背弯膝放下，切勿朝前弯腰，扭身放下。利用机械搬运重物时，应当注意机械的承载能力、机械和重物的平衡与稳定。</p>
                <h4 name="0-3-2-0-2" className="point" id="0-3-2-0-2">1.3、维修安全</h4>
                <h4>3.1 维修操作过程中的安全规范</h4>
                <p>（1）维修手册规定的安全注意事项和操作规程，要求维修人员都要熟知并严格遵守。</p>
                <p>（2）当进行车辆检修时，要拔下点火钥匙，防止他人启动车辆。</p>
                <p>（3）检修电喷发动机的燃油系统时，必须先对油路进行泄压处理，以防汽油泄漏飞溅到漏电的高压线或高温物体上，引起燃烧。检修安全气囊时必须断开蓄电池负极线，拆装安全气囊时必须轻拿轻放。对车身进行电焊作业时，应当断开蓄电池负极，以防损坏车用计算机。</p>
                <p>（4）维修运转状态的发动机时，应注意防止风扇叶片打伤或高温件烫伤人体。发动机水温很高时，不能用手直接打开散热器盖，以防有压力的高温液体烫伤人员。</p>
                <p>（5）发动机启动前应检查机油、冷却液是否符合要求；变速杆是否在空档位置；拉紧手制动。在室内启动应打开门窗，使空气畅通。启动后，应立即切断油路或气路，以免发生“飞车”事故。试验发动机时，不得在车下作业。</p>
                <p>（6）制动系统放气时，应当在放气螺栓上接上专用的储液瓶，以防制动液飞溅损伤眼睛或飞溅到轮胎、油漆上而造成损失。制动系统维修后应进行制动系统放气或踩几脚制动踏板，当制动踏板合适时，方可挂档行驶。</p>
                <p>（7）检修汽车电路时，不可乱拉电线。对于经常烧断熔丝的故障，应当查明故障原因，不可换上大容量的熔丝或用铜丝代替熔丝。</p>
                <p>（8）在车下、驾驶室下、货箱下工作时，须确保汽车支撑可靠，不能用易碎物支撑汽车。</p>
                <p>（9）在烤漆房烤漆时，汽车的烤漆时间一般是30-40min，温度一般是60-70℃，防止时间过长或温度过高引起车用计算机损坏或线路老化。</p>
                <p>（10）修理油箱需要放油时，周围应严禁烟火，并停止电焊作业。</p>
                <p>（11）在装配总成时，要采用正确的操作方法，以免受伤，甚至发生重大伤亡事故。</p>
                <p>（12）在运转零件旁边工作时，要始终注意与运转件的安全工作距离。</p>
                <p>（13）拆卸高温高压状态下的零部件，先要进行降温降压，以防高温烫伤或高压喷射伤人。</p>
                <h4>3.2 机修工安全操作规范</h4>
                <p>（1）工作前应检查所使用的的工具是否完整无损，工作中工具必须摆放整齐，不得随地乱放，工作完毕应清点检查并整理干净整齐，按照指定区域把工具存放；</p>
                <p>（2）拆装零部件时，必须按照要求使用合适的工具或专用工具，切记不可蛮干不可用硬物或手锤直接敲击零部件，零部件拆卸完毕按照顺序摆放整齐，不的随地乱推；</p>
                <p>（3）废油应倒入指定的废油收集桶里，不得随意乱放、乱倒，以防废油污染；</p>
                <p>（4）修理作业时应注意保护汽车漆面的光泽和磕碰，地毯及座位要是用保护垫布或座位套，以保持客户车辆整洁；</p>
                <p>（5）在车上修理进行清洗作业时不得有明火，不得吸烟，不允许在修车胖烧烤物品或使用喷灯；</p>
                <p>（6）修配过程中应认真检查旧件或更换件是否一样，是否符合技术要求，并严格按照维修技术规范精心进行安装和调试；</p>
                <p>（7）维修竣工的车辆启动前应先检查各部装配是否正确，是否按规定加足润滑油、冷却液、变速箱是否处于空挡、绕车检查一圈车下是否有人等；</p>
                <p>（8）发动机过热或高温室不得立即打开水箱盖，以防烫伤；</p>
                <p>（9）地面指挥车辆行驶、移位时不得站在车辆正前方或正后方并注意周围障碍物；</p>
                <p>（10）车辆维修完毕后，应立即对维修现场卫生进行清理干净；</p>

                <h4 name="0-3-2-0-3" className="point" id="0-3-2-0-3">1.4、汽车路试安全规则</h4>
                <p>（1）路试必须由安全意识和驾驶技术好的正式驾驶员担任，不允许未经批准的人员随意移动车辆或试车。</p>
                <p>（2）试车前，应检查制动、转向、灯光是否齐全有效；风扇叶片、发动机罩未装固可靠，不准进行试车。</p>
                <p>（3）仪表和各部件装配不符合要求或工作不正常，应排除后方可试车。</p>
                <p>（4）路试车辆必须有明显的试车标牌。密切注意交通情况，尤其是在测试制动效果时，务必注意车辆后方情况，并在允许试车的路段上进行。</p>
                <p>（5）行驶一段路程后，应停车检查车况，当发现有不正常的情况时，应修复后再继续试车。路试过程中，要密切注意冷却液温度、机油压力等信息，发现异常，立即停车检查排除。</p>

                <h3 name="0-3-2-1" className="point" id="0-3-2-1">2、维修工具设备的安全使用</h3>
                <h4 name="0-3-2-1-0" className="point" id="0-3-2-1-0">2.1、一般维修工具的安全规则</h4>
                <p>（1）作业中应使用大小合适的扳手。</p>
                <p>（2）一字或十字旋具只能用来拧螺钉，切勿当做冲子或撬棍使用。</p>
                <p>（3）鲤鱼钳有固定、夹紧、挤压和剪切作用，但不能用于转动。</p>
                <p>（4）当使用切削工具时，一定要使金属屑朝飞离身体的方向飞出，使双手以及手指处在刀口的后边。手柄应清洁、干燥及确保牢固地握住。</p>
                <p>（5）动力、手动或冲击工具的套筒不应互换使用。否则会导致损坏或伤害。</p>
                <p>（6）切勿用锤敲击锉刀或把锉刀当做撬棍使用。</p>
                <p>（7）使用敲击工具时，要戴合适的眼睛保护装置。</p>
                <p>（8）切勿把尖的或削尖的工具放在衣袋里。</p>
                <h4 name="0-3-2-1-1" className="point" id="0-3-2-1-1">2.2、维修设备的安全要求</h4>
                <p>（1）维修企业必须对安全设备进行经常性的维护，并定期检测，保证设备正常运行。</p>
                <p>（2）对设备的操作不了解或未经正确使用培训，切勿操作动力设备。开动设备前，应确信没有别的物件会碰到设备的运转部件。</p>
                <p>（3）操作机器设备时要全神贯注，不要环顾四周或与人交谈。</p>
                <p>（4）随车千斤顶和移动式举升机器常用来做汽车的局部举升。使用前要检查千斤顶、举升器有无损坏，确保完好方可使用。</p>
                <p>（5）使用举升机进行维修作业时，务必严格遵守举升汽车安全操作规则。</p>
                <h4 name="0-3-2-1-2" className="point" id="0-3-2-1-2">2.3、车间安全用电和防火安全常识</h4>
                <p>（1）安全用电知识</p>
                <p>1）使用电动工具设备前要核对电动工具的使用电压与电源电压是否相符。</p>
                <p>2）汽车修理的局部近距离照明和可移动照明只能采用电源为36V及以下的安全电压。</p>
                <p>3）各种电动设备，尤其是移动式电动设备，应建立经常的、定期的检查制度。</p>
                <p>4）严禁使用导线头上不带插头的灯具和电气设备。湿手赤脚时不准接触电器开关及其他电气设备。</p>
                <p>5）未经过专门训练取得上岗证者，不准进行交流电工、焊工工作。</p>
                <p>6）使用移动式电动工具和气动工具，必须熟悉其安全操作规程。</p>
                <p>7）全部电动工具，都必须有接地措施。</p>
                <p>（2）防火安全常识</p>
                <p>燃烧的三个条件是：有可燃物，有氧气，有一定的温度。</p>
                <p>防火知识 </p>
                <p>①严禁一切低燃点的油、气、醇与照明设施及带电的线路接触。</p>
                <p>②严禁用塑料桶盛装易燃液体，防止静电引发火灾。</p>
                <p>③进行电、气焊作业时，应当远离易燃易爆物品，并做好防火准备。</p>
                <p>④维修作业现场要严禁烟火，要有消防设施和消防标志。</p>
                <p>⑤严禁使用汽油清洗机件和擦洗地板。</p>
                <p>灭火工作。要根据不同的可燃物和客观条件采用不同的灭火方法和器材。</p>
                <p>汽车维修常用灭火器类型：</p>
                <p>有手提泡沫灭火筒，鸭嘴或开关灭火器，干粉灭火器，手提式1211灭火器等。</p>
                <h3 name="0-3-2-2" className="point" id="0-3-2-2">3、汽车危险性废料处理</h3>
                <p>汽车维修企业的危险品主要有：燃油添加剂、发动机机油、变速器油、制动液等。</p>
                <p>处理方法如下：</p>
                <p>1.危险品要存放于专用的危险品库，且有专人负责管理。危险品库内应有消防器材。</p>
                <p>2.危险品在运输、使用、存放时应注意密封良好、轻拿轻放，避免强光照射，避免高温。</p>
                <p>3.每一次用不完的危险品应及时回收，不得临时存放于车间。</p>
                <p>4.不能将危险性废料倒入草丛中、砂石路面、垃圾箱等。</p>
                <p>5.在车间内启动发动机时，应该将房门或排风装置打开，以便随时将废气排出车间。如果在露天作业，也不要在工作着的发动机排气管附近长时间停留。</p>
                <p>6.在作业中，千万不要用嘴去吸汽油，若将汽油吸入人体内，会导致中毒或死亡。万一吸入，应逼迫自己呕吐并及时到医院治疗。</p>
                <p>7.如果误食防冻液，应立即呕吐处理并马上到医院治疗。平时应注意对防冻液的保存，防止儿童误食。</p>
                <p>8.大部分化油器清洗剂中都含有甲基氯化物、芳香族类和乙醇。</p>
                <p>9.配制电解液时必须使用陶瓷或玻璃容器，并将硫酸慢慢倒入水中，绝对禁止将水倒入硫酸中。</p>
                <p>10.制动液有一定的毒性，对眼睛、皮肤也是有害的，要避免制动液与人的眼睛、皮肤接触，更不要误入口中，以免中毒。</p>

                <h3 name="0-3-2-3" className="point" id="0-3-2-3">4、混合动力及纯电动车型维修安全规范</h3>
                <p>搭载电动力系统的混合动力及纯电动车型，整车涉及高压的部分有：整车橙色线束、动力电池包、高压配电箱、车载充电器、太阳能充电器（装时有）、驱动电机控制器总成、DC与空调控制器总成、电动力总成、电动压缩机总成、电加热芯体PTC；为确保维修人员人身安全，避免违规操作引起安全事故，在维修高压部分时，请按照以下规范严格执行：</p>
                <h4 name="0-3-2-3-0" className="point" id="0-3-2-3-0">4.1、安全防护要求：</h4>
                <p>1、维修人员必须佩戴必要的安全防护用品，如：绝缘手套（需准备防高压电工手套以及电池电解液酸碱性两种手套）绝缘胶鞋、绝缘胶垫和防护眼镜等，其耐压级2必须大于需要测量的最高电压；</p>
                <p>2、使用前必须检查绝缘手套是否有破损、破洞或裂纹等，应完好无损，确保安全；</p>
                <p>3、使用前必须检查绝缘手套、绝缘胶鞋等防护用品，不能带水进行操作，保证内外表面干净、干燥确保安全；</p>
                <p>4、维修车辆时，必须设置专职监护人一名，监护人工作为监督维修的全过程，具体如下：</p>
                <p>4.1 监督维修人员组成、工具使用、防护用品佩戴、备件安全保护、维修安全警示牌等是否符合要求；</p>
                <p>4.2 检查紧急维修开关的接通和断开；</p>
                <p>4.3 负责对维修过程中的安全维修操作规程进行检查，监护人要按安全维修操作规程指挥操作，维修人员在做完一个操作后要告知监护人，监护人要在作业流程单上做标记；</p>
                <p>4.4 监护人要认真负起责任，确保维修过整的安全，避免发生安全责任事故；</p>
                <p>4.5 监护人及维修人员必须具备国家认可的《特种作业操作证（电工）》与《初级（含）以上电工证》（职业资格证书）；</p>
                <p>4.6 监护人及维修人员必须经过混合动力及纯电动车型新车型培训，并通过考核；</p>
                <p>5、严禁未培训的人员进行高压部分检修，禁止一切带有侥幸心理的危险操作，避免发生安全事故；</p>
                <h4 name="0-3-2-3-1" className="point" id="0-3-2-3-1">4.2、安全维修操作规范</h4>
                <p>1、高压部件识别：</p>
                <p>1.1 整车橙色线束均为高压线；</p>
                <p>1.2 动力电池包连至电源管理器的红色电压采样线束；</p>
                <p>1.3 高压零部件：动力电池包、高压配电箱、车载充电器、太阳能充电器（装时有）、驱动电机控制器总成、DC与空调控制器总成、电动力总成、电动压缩机总成、电加热芯体PTC；</p>
                <p>2、检修高压系统时，点火开关必须处于OFF档（若为智能钥匙系统则使车辆开关拔下后，由专职监护人员保管，并确保在维修过程中不会有人将其插到高压配电箱上）</p>
                <p>2.1 断开紧急维修开关只是切断了从高压配电箱到各个高压用电设备的电源，并不能切断动力电池包到高压配电箱的电源；</p>
                <p>2.2 当需要维修或更换高压配电箱时，应小心拔出连接动力电池包的电缆正、负极高压接插件，使用绝缘胶带包好裸露出的桩头，避免触电；</p>
                <p>3、在断开紧急维修开关5分钟后，检修高压系统前应使用万用表检测量整车高压回路，确保无电；</p>
                <p>3.1 确定方法：拔下紧急维修开关后，测量动力电池包正极和车身之间的电压来初步判断是否漏电，若检测到电压大于等于50V，应立即停止操作，《按附件五：动力电池包漏电检测方法》检查</p>
                <p>3.2 使用万用表测量高压时，需要选择正确量程，检测万用表精度不低于0.5级，要求具有直流电压测量档位，量程范围不小于或等于500V，并遵守“单手操作”原则；</p>
                <p>3.3 所使用的的万用表一根表笔线上配备绝缘鳄鱼夹（要求耐压为3KV过电流能力大于5A）；测量时先把鳄鱼夹夹到电路的一个端子，然后用另一只表笔接到需测量端子测量读书。每次测量时只能用一只手握住表笔；测量过程中，严禁触摸表笔金属部分；</p>
                <p>4、调试高、低压系统注意事项：</p>
                <p>4.1 调试低压前必须断开紧急维修开关；</p>
                <p>4.2 调试高压时，必须由专职监护人指挥装配紧急维修开关；</p>
                <p>4.3 调试高压必须在低压调试好的前提下调试，便于判断动力电池包是否有漏电的情况，如有漏电情况应及时检查，不能进行高压调试；</p>
                <p>5、拆装动力电池包总成时，首先把高压配电箱连接线束插接件用绝缘胶带缠好，拆装过程不要损坏线束，以免发生触电危险；</p>
                <p>6、检修或更换高压线束、油管等经过车身钣金孔的部件时，需注意检查车身钣金的防护是否正常，避免线束、油管磨损；</p>
                <br/>
                <div><strong style={{color:'#6699FF'}}>附件：</strong>处理安全生产问题参照<a href="javascript:void(0);" type="primary" id='Enclosure41' title="《云豪集团安全生产事故（事件）处理规则》" onClick={(value)=>this.showDrawer(value)}>《云豪集团安全生产事故（事件）处理规则》</a>执行。</div>
                <br/>
                <h3 name="0-3-2-4" className="point" id="0-3-2-4">5、安全生产事故（事件）处理细则</h3>
                <h4>第一部分 总则</h4>
                <p>第一条 为了更好地贯彻安全生产方针、政策、法规，落实安全生产的各项规章制度，促进企业安全发展，结合公司实际，特制定本规则。</p>
                <p>第二条
                    公司建立安全问责制度、安全奖管理办法、人身伤亡事故处理办法、道路交通事故处理办法、设备事故处理办法、消防事故处理办法、生产事故处理办法、治安事件处理办法、违章违制处理办法等制度，促进公司安全生产岗位责任制的全面落实。</p>
                <p>第三条 本规则是公司安全生产事故（事件）处理工作的纲领性文件。 公司合同制职工均按照本规则执行，其他在公司区域作业的人员，按照有关协议及相关规定执行。</p>
                <p>本规则所述事故（事件），包括公司的各类事故、事件及违章违制现象。</p>
                <p>第四条 安全生产事故（事件）的事后处理工作，坚持“谁主管谁负责、谁在岗谁负责、谁出问题谁负责”的原则。 各事业部负责所辖区域安全生产事故（事件）的日常管理工作。</p>

                <h4>第二部分 安全生产事故等级分类</h4>
                <p>第五条 安全生产事故是指职业活动或有关活动过程中发生的意外、突发性事件的总称，通常会使正常活动中断、造成人员伤亡或财产损失。</p>
                <p>1、按伤害程度分:职工伤亡事故按伤害程度分为轻伤事故、重伤事故、死亡事故、重大死亡事故、特大死亡事故。</p>
                <p>2、按经济损失程度分:根据事故造成的经济损失程度，事故通常分为一般损失事故、较大损失事故、重大损失事故、特大损失事故。</p>
                <p>第六条 公司根据事故伤害程度、经济损失程度，将各类事故分为四个等级，即：Ⅰ级（轻微事故）、Ⅱ级（一般事故）、Ⅲ级（重大事故）、Ⅳ级（重特大事故）。</p>
                <p>Ⅰ级事故，如：轻微交通事故、出现火警； </p>
                <p>Ⅱ级事故，如：轻微人身伤害事故、一般交通事故、一般火灾、一般设备事故；</p>
                <p>Ⅲ级事故，如：轻伤事故、重大交通事故、重大火灾、重大设备事故；</p>
                <p>Ⅳ级事故，如：重伤及工亡事故、特大交通事故、特大火灾事故、特大设备事故。</p>
                <p>第七条 安全生产事故等级应由事故调查组分析确定。</p>

                <h4>第三部分 安全生产事故责任分类</h4>
                <p>第八条 安全生产事故根据性质分为责任事故、非责任事故或破坏事故。 责任事故和破坏事故应进行处罚。 非责任事故可不进行处罚。</p>
                <p>第九条 为准确地对不同事故责任人进行处罚，应根据事故调查组所确认的事实，分清事故责任：</p>
                <p>1、直接责任者，指其行为与事故的发生有直接关系的人员。</p>
                <p>2、主要责任者，指对事故的发生起主要作用的人员。</p>
                <p>3、领导责任者，指对事故的发生负有领导责任的人员。</p>
                <p>第十条 安全生产事故责任的认定应由事故调查组确定。</p>

                <h4>第四部分 违章违制等级分类</h4>
                <p>第十一条 公司将各类违章分为四个等级，即：Ⅰ级（行为疏忽）、Ⅱ级（一般违章）、Ⅲ级（严重违章）、Ⅳ级（重大违章）。</p>
                <p>第十二条 违章行为等级的评价，由各专业检查组或主管部门组织三名以上（含）专业人员进行会商确定，公司安全部门具有最终裁决权。</p>

                <h4>第五部分 安全生产事故（事件）的报告、调查处理</h4>
                <p>第十三条 公司安全生产事故管理部门为相关事故报告的主管部门，负责事故（事件）的接案、上报和事故（事件）调查处理的组织工作。</p>
                <p>第十四条 公司安全生产事故（事件）主管部门负责完善事故（事件）报告的实施办法。</p>
                <p>第十五条
                    安全生产事故（事件）发生后，公司安全生产事故主管部门应及时组织事故（事件）调查组，开展事故（事件）调查、分析工作，确定事故（事件）性质，划分事故（事件）责任。上级主管部门组织调查组的，公司安全生产事故（事件）主管部门应积极配合其工作。</p>
                <p>第十六条 公司安全生产事故主管部门应建立和相关单位关于事故调查处理的协调机制，完善沟通渠道和信息公开办法。</p>
                <h4>第六部分 惩罚</h4>
                <p>第十七条 安全生产事故（事件）发生后，对相关部门领导和责任者的惩罚工作，必须结合事故（事件）的类型、等级和责任大小有针对性的进行。</p>
                <p>第十八条 惩罚类型</p>
                <p>1、根据情节的轻重程度，及时采取批评教育、书面检查、通报全厂、待岗学习、经济处罚、行政处罚等办法予以处罚。除对直接责任者进行处罚外，同时追究部门各级领导及与此事件相关的所有人员的责任。</p>
                <p>2、经济处罚根据危害程度和损失情况、责任大小，可处以罚款、赔偿损失、降低工资、扣除奖金、没收押金等。</p>
                <p>3、行政处罚根据危害程度和损失情况、责任大小可处以警告、诫勉谈话、记过、降职、降级、留厂查看、开除等。</p>
                <p>4、性质特别严重、情节恶劣，触犯刑律者，追究法律责任</p>
                <h4>第十九条
                    各类事故（事件）的惩罚标准：根据公司董事会决定，在公司安全生产过程中发生的责任性事故（事件）对公司造成的财产损失，各责任者需承担损失，承担比例为：事故（事件）直接责任者承担40%，直接责任者的部门第一责权人承担30%，公司承担30%。</h4>
                <p>第二十条 惩罚程序</p>
                <p>1、经济处罚由相关主管部门提出处理意见，报分管副总经理批准后执行。</p>
                <p>2、行政处罚由相关主管部门提出处理意见，按公司有关规定参照任命程序，报有关领导批准后执行。 </p>

                <h4>第七部分 奖励</h4>
                <p>第二十一条 奖励类型</p>
                <p> 奖励实行精神奖励和物质奖励相结合的原则。物质奖励可发给一次性奖金、奖品或晋级，精神奖励包括记功、授予荣誉称号等。</p>
                <p>第二十二条 公司设立“安全奖”，制定奖罚措施，对安全工作做得好的部门进行奖励，具体办法另行制定。</p>
                <p>第二十三条 具有以下情况的，公司可予以奖励</p>
                <p>1、在安全技术、工业卫生方面积极采取先进技术，提出重要建议被采用有明显的效果者，有发明创造或科研成果，成绩显著的。</p>
                <p>2、认真贯彻公司的安全生产方针、规章、制度，在预防事故、安全生产过程中作出显著成绩的。</p>
                <p>3、制止违章指挥、制止违章作业避免事故发生者</p>
                <p> 第二十四条 本规则自公布之日起执行。</p>
                <br/>
                <h2 name="0-3-3" className="point" id="0-3-3">四、网络安全管理细则</h2>
                <p>计算机网络为公司局域网提供网络基础平台服务和互联网接入服务，由电商中心负责计算机连网和网络管理工作。为保证公司局域网能够安全可靠地运行，充分发挥信息服务方面的重要作用，更好地为公司员工提供服务，现制定并发布《网络安全管理细则》。</p>
                <h3 name="0-3-3-0" className="point" id="0-3-3-0">一、网络设备及信息安全管理细则</h3>
                <p>1、所有网络设备（包括路由器、交换机、集线器、光纤、网线等）均归电商中心所管辖，其安装、维护等操作由电商中心工作人员进行，其他任何人不得破坏或擅自维修，考核积分0-400分；</p>
                <p>2、所有公司内计算机网络部分的扩展必须经过电商中心实施或批准实施，未经许可任何部门不得私自连接交换机、集线器等网络设备，不得私自接入网络。电商中心有权拆除员工私自接入的网络线路并报告上级领导，考核积分0-400分；</p>
                <p>3、各分公司的联网工作必须事先报经电商中心，由电商中心做网络实施方案。</p>
                <p>4、接入公司局域网的客户端计算机的网络配置由电商中心部署的服务器统一管理分配，包括：用户计算机的IP地址、网关、DNS和WINS服务器地址等信息。未经许可，任何人不得更改网络配置。考核积分0-200分；</p>
                <p>5、网络安全：严格执行国家《网络安全管理制度》。对在公司局域网上从事任何有悖网络法规活动者，将视其情节轻重交有关部门或公安机关处理。</p>
                <p>6、公司员工具有信息保密的义务。任何人不得利用计算机网络泄漏公司机密、技术资料和其它保密资料。</p>
                <p>7、严禁外来人员对计算机数据和文件进行拷贝或抄写以免泄漏公司机密，对公司办公系统或其它公司内部平台帐号不得相互知晓，每个人必须保证自己帐号的唯一登陆性，否则由此产生的数据安全问题由其本人负全部责任。</p>
                <p>8、各部门人员必须及时做好各种数据资料的录入、修改、备份和数据保密工作，保证数据资料的完整准确和安全性。</p>
                <p>9、任何人不得在局域网络和互联网上发布有损公司形象和职工声誉的信息、影像资料、声频资料等，未经公司企宣部批准，不得在办公室、生产车间、员工宿舍等区域进行网络直播、拍抖音视频等行为。对违反规定者，考核积分0-500分；</p>
                <p>10、任何人不得扫描、攻击公司计算机网络和他人计算机。不得盗用、窃取他人资料、信息等。</p>
                <p>11、为了避免或减少计算机病毒对系统、数据造成的影响，接入公司局域网的所有用户必须遵循以下规定：</p>
                <p>（1）任何部门和个人不得制作计算机病毒；不得故意传播计算机病毒，危害计算机信息系统安全；不得向他人提供含有计算机病毒的文件、软件、媒体。</p>
                <p>（2）采取有效的计算机病毒安全技术防治措施。建议客户端计算机安装使用企宣部部署发布的相关杀毒软件和360安全卫士对病毒和木马进行查杀。</p>
                <p>（3）定期或及时用更新后的新版杀病毒软件检测、清除计算机中的病毒。</p>
                <p>12、公司的互联网连接只允许员工为了工作、学习和工作之余的休闲使用，使用时必须遵守有关的国家、企业的法律和规程，严禁传播淫秽、反动等违犯国家法律和中国道德与风俗的内容。一经发现公司电商中心有权撤消违纪者互联网的使用权。使用者必须严格遵循以下内容：</p>
                <p>（1）从中国境内向外传输技术性资料时必须符合中国有关法规。</p>
                <p>（2）遵守所有使用互联网的网络协议、规定和程序。</p>
                <p>（3）不能利用邮件服务作连锁邮件、垃圾邮件或分发给任何未经允许接收信件的人。</p>
                <p>（4）任何人不得在网上制作、查阅和传播宣扬反动、淫秽、封建迷信等违犯国家法律和中国道德与风俗的内容。</p>
                <p>（5）不得传输任何非法的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的信息资料。</p>
                <p>（6）不得传输任何教唆他人构成犯罪行为的资料，不能传输助长国内不利条件和涉及国家安全的资料。</p>
                <p>（7）不能传输任何不符合当地法规、国家法律和国际法律的资料。</p>
                <p>13、为了发挥好网站的形象宣传作用，各分公司要及时向企宣部提供有关资料，以便充实网站内容，加大宣传影响。由企宣部统一整理、编辑上传及内容更新。</p>
                <h3 name="0-3-3-1" className="point" id="0-3-3-1">二、网络宣传管理细则</h3>
                <p>1、个人网络获取的未经授权的图片，在任何环境下都不得以公司的名义发布。</p>
                <p>2、公司网站、微信公众号等文章素材必须真实原创，禁止从网上转载或使用未经授权的图片，如使用厂家提供的图片或文章素材，需经过网络营销管理公司审核通过后方可使用。</p>
                <p>3、互联网发布的信息必须真实有效，禁止做虚假、夸大事实等促销活动。严禁使用广告中相关规定禁止使用的不可度量的相关敏感词。附：敏感词汇表。</p>
                <p>4、任何对外宣传所涉及的设计的海报、图册、图片或背景采用的图片等必须采用原创图片或经过授权可在互联网进行商用宣传的方可使用，并且把原始资料存档做为原创版权证据。</p>
                <p>5、凡发生网络安全和信息泄密事件或因员工上网行为违反国家相关法律的如情形严重造成国家、公司或他人财产损失的，无论员工是否有意，均需依法承担民事责任。公司将按照有关法规移交司法机关处理，并追究当事人责任。</p>
                <p>6、对违反上述制度者，考核当事人及上级主管0-500分/次，如给公司带来不良后果，视情节严重程度给予相应处罚。</p>
                <h4>下面为不可度量的相关敏感词明细表：</h4>
                <img src={minganci1} alt="" style={{
                    width  : '800px',
                    display: 'block',
                    margin : '0 auto'
                }}/>
                <p></p>
                <h2 name="0-3-4" className="point" id="0-3-4">五、纪律检查委员会职责</h2>
                <p>为有效落实云豪集团《员工手册》各项管理细则及规章制度，确保集团公司生产、生活等各方面安全，对纪律检查委员会的职能说明如下</p>
                <p>一、纪律检查委员会是一个综合机构，具有执“法”权，是集团公司最高行政执行机构，有权利对集团公司所有机构的人、财、物、产、供、销各个领域进行纪律检查以及处罚或奖励。</p>
                <p>二、纪律检查委员会由监察部、工会、财务中心、办公室、人力资源部、资产部、法务部、云豪学院及各区域行政管理责任人组成。其中监察部是纪律检查委员会的常设执行机构，负主要执行责任。</p>
                <h3>三、新一届纪律检查委员会人员构成</h3>
                <p>1、主任：王云厅</p>
                <p>2、副主任：郭军、韩立学、傅雪梅</p>
                <p>3、委员：郝惠东、吕洪波、王洁、王剑英、郑彬、郭海江、孟庆彪、刘永强、李西安、张雨、蔺帅、徐斌、江河。</p>
                <p>4、工作人员：从上述各部室及区域公司根据工作需要随时抽调人员。</p>
                <h3>四、纪律检查委员会工作内容</h3>
                <p>1、大兴、延庆、天津基地由监察部牵头每月至少现场检查1次。</p>
                <p>2、沈阳、石家庄、新疆基地由监察部牵头每季度至少现场检查1次。</p>
                <p>3、纪律检查委员会的委员随时检查。</p>
                <p>4、纪律检查委员在集团公司内部聘用不同层级、不同岗位的兼职“纪检协助员”，可随时检查，提供相关信息，被聘用的“纪检协助员”每月会有固定的劳务费。</p>
                <p>5、集团公司每位员工都可充当“纪检志愿者”，对集团内部所有违规、违纪行为进行上报，均可获得动态积分。</p>
                <h3>五、纪律检查委员会的检查重点</h3>
                <h3>人：</h3>
                <p>1、个人仪容仪表、言谈举止</p>
                <p>2、宿舍、食堂环境卫生</p>
                <h3>财：</h3>
                <p>1、各部门财务制度执行情况</p>
                <h3>物：</h3>
                <p>1、办公环境</p>
                <p>2、服务车、公务车车容车况</p>
                <p>3、各部仓储、库房及储物间的环境卫生、物品码放、账物相符</p>
                <p>4、浪费及损坏生产、生活物资</p>
                <h3>产：</h3>
                <p>1、车间生产安全</p>
                <p>2、物流安全</p>
                <p>3、车间及与生产相关的各部门的作业规范</p>
                <p>4、外出服务规范</p>
                <h3>供：</h3>
                <p>1、各部门采购制度执行情况</p>
                <h3>销：</h3>
                <p>1、客服礼仪</p>
                <p>2、营销流程</p>
                <p>3、合同、公章管理</p>
                <p>对上述违规行为的考核标准参照云豪集团《员工手册》或各管理公司作业流程及作业标准。</p>
                <h3>六、纪律检查委员会所有相关人员的报酬</h3>
                <p>1、委员及委员以上人员是工作职责之一，没有其他报酬，工作不到位，只有处罚</p>
                <p>2、“纪检协助员”每人每月奖励200元，每月至少上报2条违规行为，少于2条不予报酬。</p>
                <p>3、“纪检志愿者”每上报1条并经采纳，给予100动态积分奖励。</p>
                <p>4、发现问题及时制止，挽回损失的酌情给予奖励。</p>
                <p>5、凡有不实举报者，撤销纪检委工作人员资格并进行相应处罚。</p>
                <h3>七、上报途径</h3>
                <p>1、纪律检查委员会的所有工作人员对发现的违规行为通过“纪律检查委员会直通信箱”上报，如实填写违规信息：包括时间、地点、人员、事件描述、现场图片等，可采取“匿名”或“实名”提报方式（匿名提报不予奖励）。</p>
                <p>2、集团全体人员对公司管理、市场开拓、创新发展等各方面有合理建议，可通过“办公室直通信箱”提出，建议一经被集团公司采纳，将酌情给予建议人动态积分奖励。</p>
                <p>3、可当面或微信、电话的形式向纪律检查委员会主任或副主任直接汇报。</p>
                <p></p>
              



           
            </div>
        </div>
        )
    }
}

export default Section$;